import { render, staticRenderFns } from "./EditCompanyAddress.vue?vue&type=template&id=57042f98&"
import script from "./EditCompanyAddress.vue?vue&type=script&lang=js&"
export * from "./EditCompanyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports